import { api } from '.'

export const otpApi = api.injectEndpoints({
  endpoints: build => ({
    otpVerify: build.mutation({
      query: ({ mobile_phone, code }: { mobile_phone: string; code: string }) => ({
        url: `/mega_cards/application/otp-verify/`,
        method: 'POST',
        body: { mobile_phone, code }
      })
    }),
    offlineOtpVerify: build.mutation({
      query: ({ code }: { code: string }) => ({
        url: `/mega_cards/application/offline-otp-verify/`,
        method: 'POST',
        body: { code }
      })
    })
  })
})

export const { useOtpVerifyMutation, useOfflineOtpVerifyMutation } = otpApi
